import React, { useState } from 'react';
import { 
  FaNewspaper, FaBookOpen, FaChartLine, FaShieldAlt, 
  FaCheckCircle, FaChevronDown, FaRegCalendarAlt, FaUser, FaArrowRight 
} from 'react-icons/fa';
import { Helmet } from 'react-helmet-async';
const Articles = () => {
  // State for Accordion FAQ toggling
  const [openFaq, setOpenFaq] = useState(null);

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  const articlesList = [
    {
      title: "Strategic Tax Planning: How to Optimize Your Wealth Legally in 2026",
      category: "Tax Advisory",
      date: "June 14, 2026",
      author: "Lotoswealth Research Team",
      excerpt: "Explore proactive, year-round tax strategies designed to lower your annual tax burden, optimize capital gains, and protect your hard-earned wealth within full regulatory compliance."
    },
    {
      title: "Navigating Global Markets: The Importance of Offshore Diversification",
      category: "Global Investments",
      date: "May 28, 2026",
      author: "Senior Wealth Strategist",
      excerpt: "Why relying solely on domestic markets exposes your portfolio to concentrated risk, and how you can leverage the LRS route to invest in international technology giants."
    },
    {
      title: "Securing Your Legacy: Wills vs. Private Family Trusts",
      category: "Estate Planning",
      date: "May 12, 2026",
      author: "Legal & Succession Advisory",
      excerpt: "A deep dive into inheritance structuring, bypassing probate delays, safeguarding assets from creditors, and ensuring seamless multi-generational wealth transfer."
    },
    {
      title: "Private Credit vs. Traditional Bonds: Unlocking Higher Yields",
      category: "Alternative Assets",
      date: "April 20, 2026",
      author: "Alternative Investments Desk",
      excerpt: "An introduction to senior secured private debt, bespoke lending yields, and why sophisticated investors are allocating capital to non-bank credit structures."
    },
    {
      title: "The FIRE Movement in India: How to Retire Decades Early",
      category: "Financial Planning",
      date: "April 05, 2026",
      author: "Retirement Planning Specialists",
      excerpt: "Breaking down the mathematics of financial independence, high savings rates, aggressive equity compounding, and the 4% safe withdrawal rule."
    },
    {
      title: "Corporate Financial Wellness: Boosting Workforce Productivity",
      category: "Corporate Advisory",
      date: "March 18, 2026",
      author: "Corporate Wellness Team",
      excerpt: "How eliminating employee financial stress through structured education workshops and tax-saving seminars drives organizational retention and engagement."
    }
  ];

  const faqs = [
    {
      q: "How often are new articles and market insights published?",
      a: "Our research and advisory teams publish fresh articles, tax updates, and market commentaries weekly to keep our clients informed about evolving financial landscapes and regulatory changes."
    },
    {
      q: "Can I share these articles or subscribe to a newsletter?",
      a: "Yes! All our articles can be shared via social media or email. You can also subscribe to our regular wealth management newsletter to receive expert insights directly in your inbox."
    },
    {
      q: "Are the tax tips applicable for both residents and NRIs?",
      a: "We categorize our articles clearly. We publish dedicated guides covering domestic Indian taxation, NRI compliance, DTAA benefits, and cross-border investment regulations."
    },
    {
      q: "How can I consult an advisor regarding a specific topic covered in an article?",
      a: "If an article sparks a question about your personal portfolio or tax strategy, you can easily schedule a consultation with our expert advisors directly through our website."
    }
  ];

  return (
    <main className="articles-page">
      <Helmet>
  {/* Basic SEO */}
  <title>Financial Articles & Investment Insights | Wealth Management Blog | Lotoswealth</title>

  <meta
    name="description"
    content="Read the latest financial articles from Lotoswealth covering Wealth Management, Financial Planning, Portfolio Management Services (PMS), Mutual Funds, Stock Market, Tax Planning, Retirement Planning, Estate Planning, Home Loans, Car Loans, Education Loans, and investment strategies in Hyderabad."
  />

  <meta
    name="keywords"
    content="Financial Articles Hyderabad, Investment Articles Hyderabad, Wealth Management Blog Hyderabad, Financial Planning Articles Hyderabad, Investment Insights Hyderabad, Stock Market Articles Hyderabad, Mutual Funds Articles Hyderabad, Portfolio Management Articles Hyderabad, PMS Articles Hyderabad, Tax Planning Articles Hyderabad, Retirement Planning Articles Hyderabad, Estate Planning Articles Hyderabad, Investment Tips Hyderabad, Personal Finance Hyderabad, Wealth Creation Hyderabad, Home Loan Articles Hyderabad, Car Loan Articles Hyderabad, Education Loan Articles Hyderabad, Financial News Hyderabad, Lotoswealth Blog"
  />

  <meta name="robots" content="index, follow" />
  <meta name="author" content="Lotoswealth" />
  <meta name="language" content="English" />

  <link
    rel="canonical"
    href="https://www.lotoswealth.com/articles"
  />

  {/* Open Graph */}
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="Lotoswealth" />
  <meta
    property="og:url"
    content="https://www.lotoswealth.com/articles"
  />
  <meta
    property="og:title"
    content="Financial Articles & Investment Insights | Lotoswealth"
  />
  <meta
    property="og:description"
    content="Explore expert articles on Wealth Management, Financial Planning, Mutual Funds, Stock Market Investing, Portfolio Management, Tax Planning, Retirement Planning, and personal finance."
  />
  <meta
    property="og:image"
    content="https://www.lotoswealth.com/images/lotoswealth-logo.png"
  />

  {/* Twitter */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta
    name="twitter:title"
    content="Financial Articles & Investment Insights | Lotoswealth"
  />
  <meta
    name="twitter:description"
    content="Stay informed with expert financial articles, investment insights, wealth management strategies, mutual fund updates, stock market analysis, and retirement planning tips."
  />
  <meta
    name="twitter:image"
    content="https://www.lotoswealth.com/images/lotoswealth-logo.png"
  />
</Helmet>
      {/* =========================================
          1. HERO SECTION (With Ticker & Slow Zoom)
      ========================================= */}
      <div className="hero-wrapper position-relative" style={{ height: '100vh', minHeight: '800px', overflow: 'hidden' }}>
        
        <div className="position-absolute top-0 start-0 w-100 h-100 z-0 animate-slow-zoom">
          <img 
            src="/images/articles.jpg" 
            alt="Financial Articles and Insights" 
            className="w-100 h-100 object-fit-cover"
          />
        </div>

        {/* Slanted Panels Overlay */}
        <div className="panels-container position-absolute top-0 start-0 w-100 h-100 z-1 d-flex">
          <div className="slanted-panel panel-1"></div>
          <div className="slanted-panel panel-2"></div>
          <div className="slanted-panel panel-3"></div>
          <div className="slanted-panel panel-4"></div>
        </div>

        {/* --- Floating Main Header Text (Perfectly Centered) --- */}
        <div className="container hero-main-text text-center position-absolute top-50 start-50 translate-middle z-3 w-100 px-4">
          <h1 className="fw-bold display-4 animate-slide-up delay-1 mb-3 text-white" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.5)' }}>
            Articles & Expert Insights
          </h1>
          <h2 className="animate-slide-up delay-2 fw-bold text-white mb-4" style={{ textShadow: '1px 1px 3px rgba(0,0,0,0.5)' }}>
            Stay Informed With Professional Wealth Management Commentaries
          </h2>
          <p className="hero-description animate-slide-up delay-3 text-white mx-auto" style={{ maxWidth: '950px', fontSize: '1.1rem', lineHeight: '1.7', textShadow: '1px 1px 3px rgba(0,0,0,0.5)' }}>
            Welcome to Lotoswealth's Knowledge Hub. Navigating the world of finance, taxation, global markets, and estate planning requires clarity and reliable information. Our expert-authored articles provide deep dives into modern wealth strategies, regulatory updates, and market trends.
          </p>
          <p className="hero-description mt-3 animate-slide-up delay-4 text-white mx-auto" style={{ maxWidth: '950px', fontSize: '1.1rem', lineHeight: '1.7', textShadow: '1px 1px 3px rgba(0,0,0,0.5)' }}>
            Whether you are looking to refine your tax roadmap, explore alternative investment funds, understand the FIRE movement, or secure your family's estate, our insights are designed to empower your financial decision-making.
          </p>
          <p className="hero-description mt-3 animate-slide-up delay-5 text-white mx-auto" style={{ maxWidth: '950px', fontSize: '1.1rem', lineHeight: '1.7', textShadow: '1px 1px 3px rgba(0,0,0,0.5)' }}>
            Explore our latest publications and stay ahead of the curve with research-backed financial commentary.
          </p>
        </div>

        {/* --- Scrolling Stock Ticker --- */}
        <div className="stock-ticker position-absolute bottom-0 w-100 z-3 bg-dark text-white border-top border-bottom border-secondary py-2" style={{ opacity: 0.9 }}>
          <div className="ticker-track">
            {/* First Set */}
            <div className="ticker-item text-white border-end border-secondary"><strong>APOLLOHOSP</strong> 8,894.00 <span className="text-danger">-63.00 (-0.70%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>ASIANPAINT</strong> 2,768.60 <span className="text-success">21.30 (0.78%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>AXISBANK</strong> 1,250.00 <span className="text-success">20.50 (1.67%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>BAJAJ-AUTO</strong> 11,519.00 <span className="text-danger">-2.00 (-0.02%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>BAJAJFINSV</strong> 2,085.60 <span className="text-success">56.50 (2.78%)</span></div>
            
            {/* Duplicated Set for Infinite Scrolling */}
            <div className="ticker-item text-white border-end border-secondary"><strong>APOLLOHOSP</strong> 8,894.00 <span className="text-danger">-63.00 (-0.70%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>ASIANPAINT</strong> 2,768.60 <span className="text-success">21.30 (0.78%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>AXISBANK</strong> 1,250.00 <span className="text-success">20.50 (1.67%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>BAJAJ-AUTO</strong> 11,519.00 <span className="text-danger">-2.00 (-0.02%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>BAJAJFINSV</strong> 2,085.60 <span className="text-success">56.50 (2.78%)</span></div>
          </div>
        </div>
      </div>

      {/* =========================================
          2. WHY FINANCIAL LITERACY MATTERS (Soft Teal Theme)
      ========================================= */}
      <section className="py-5" style={{ backgroundColor: '#f0f9f6' }}>
        <div className="container py-4">
          <div className="row align-items-center g-5">
            <div className="col-lg-6 animate-slide-up delay-1">
              <h2 className="fw-bold mb-4 text-dark">
                Empowering Your Financial Decisions Through Knowledge
              </h2>
              <p className="text-muted line-height-lg">
                In an era of rapid economic changes, staying informed is your best defense against volatility and uncertainty. Financial literacy forms the bedrock of sustainable wealth creation and long-term security.
              </p>
              <p className="text-muted line-height-lg">
                Our articles bridge the gap between complex financial concepts and actionable execution. We break down tax laws, market movements, and asset strategies into clear, digestible insights so you can take control of your financial destiny.
              </p>
            </div>
            <div className="col-lg-6 animate-slide-up delay-2">
              <div className="p-4 bg-white rounded-4 shadow-sm border-start border-teal border-5">
                <h4 className="fw-bold text-teal mb-3">What You Will Discover</h4>
                <ul className="list-unstyled text-muted mb-0">
                  <li className="mb-2"><FaCheckCircle className="text-teal me-2" /> <strong>Expert Commentaries:</strong> Analysis from certified wealth and tax advisors.</li>
                  <li className="mb-2"><FaCheckCircle className="text-teal me-2" /> <strong>Actionable Strategies:</strong> Practical steps for portfolio and tax optimization.</li>
                  <li className="mb-2"><FaCheckCircle className="text-teal me-2" /> <strong>Market Trends:</strong> Deep dives into alternative assets, private credit, and global funds.</li>
                  <li className="mb-2"><FaCheckCircle className="text-teal me-2" /> <strong>Regulatory Updates:</strong> Clear breakdowns of tax law changes and compliance rules.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* =========================================
          3. FEATURED ARTICLES GRID (Crisp White)
      ========================================= */}
      <section className="py-5 bg-white" style={{ backgroundImage: "url('/images/lotoswealth-bg.jpg')", backgroundSize: 'cover', backgroundPosition: 'center' }}>
        
        <div className="container py-4">
          <div className="text-center mb-5 animate-slide-up delay-1">
            <h2 className="fw-bold text-white">📰 Latest Articles & Publications</h2>
            <p className="text-white">Explore our repository of expert financial advice and wealth strategies.</p>
          </div>

          <div className="row g-4">
            
            {articlesList.map((article, index) => (
              <div key={index} className="col-lg-4 col-md-6 animate-slide-up delay-1">
                <div className="p-4 bg-light rounded-4 h-100 hover-lift-card border-bottom border-teal border-4 d-flex flex-column justify-content-between">
                  <div>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <span className="badge bg-teal text-white px-3 py-2 small">{article.category}</span>
                      <span className="text-muted small d-flex align-items-center">
                        <FaRegCalendarAlt className="me-1 text-teal" /> {article.date}
                      </span>
                    </div>
                    <h5 className="fw-bold mb-3 text-dark">{article.title}</h5>
                    <p className="text-muted small mb-4">{article.excerpt}</p>
                  </div>
                  <div>
                    <div className="d-flex align-items-center mb-3 text-muted small">
                      <FaUser className="me-2 text-teal" /> <span>{article.author}</span>
                    </div>
                    <button className="btn btn-outline-teal btn-sm w-100 d-flex align-items-center justify-content-center gap-2 fw-bold">
                      Read Full Article <FaArrowRight size={12} />
                    </button>
                  </div>
                </div>
              </div>
            ))}

          </div>
        </div>
      </section>

      {/* =========================================
          4. OUR CONTENT CATEGORIES (Dark Slate)
      ========================================= */}
      <section className="py-5 text-white" style={{ backgroundColor: '#0a192f' }}>
        <div className="container py-4">
          <div className="text-center mb-5 animate-slide-up delay-1">
            <h2 className="fw-bold text-white">🔄 Explore by Topic</h2>
            <p className="text-light opacity-75">Targeted insights based on your specific financial interests.</p>
          </div>

          <div className="row g-4">
            
            <div className="col-md-6 col-lg-4 animate-slide-up delay-1">
              <div className="p-4 bg-white text-dark rounded-4 shadow-sm h-100 border-top border-4 border-teal">
                <h5 className="fw-bold text-teal mb-2">Tax Advisory Insights</h5>
                <p className="small text-muted mb-0">Guides on ITR filing, capital gains optimization, corporate taxes, and DTAA compliance for residents and NRIs.</p>
              </div>
            </div>

            <div className="col-md-6 col-lg-4 animate-slide-up delay-2">
              <div className="p-4 bg-white text-dark rounded-4 shadow-sm h-100 border-top border-4 border-teal">
                <h5 className="fw-bold text-teal mb-2">Global & Offshore Investing</h5>
                <p className="small text-muted mb-0">Commentaries on international markets, LRS remittance rules, foreign asset reporting, and cross-border diversification.</p>
              </div>
            </div>

            <div className="col-md-6 col-lg-4 animate-slide-up delay-3">
              <div className="p-4 bg-white text-dark rounded-4 shadow-sm h-100 border-top border-4 border-teal">
                <h5 className="fw-bold text-teal mb-2">Alternative Assets & AIFs</h5>
                <p className="small text-muted mb-0">Deep dives into private equity, private credit, structured products, REITs, and high-yield non-traditional investments.</p>
              </div>
            </div>

            <div className="col-md-6 col-lg-6 animate-slide-up delay-4">
              <div className="p-4 bg-white text-dark rounded-4 shadow-sm h-100 border-top border-4 border-teal">
                <h5 className="fw-bold text-teal mb-2">Estate & Succession Planning</h5>
                <p className="small text-muted mb-0">Articles focusing on Will drafting, private family trusts, business succession, and tax-efficient wealth transfer.</p>
              </div>
            </div>

            <div className="col-md-12 col-lg-6 animate-slide-up delay-5">
              <div className="p-4 bg-white text-dark rounded-4 shadow-sm h-100 border-top border-4 border-teal">
                <h5 className="fw-bold text-teal mb-2">Financial Planning & FIRE</h5>
                <p className="small text-muted mb-0">Practical strategies for goal-based investing, retirement corpus building, FIRE movement math, and wealth preservation.</p>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* =========================================
          5. WHO WE SERVE & WHY CHOOSE US (Soft Blue-Gray)
      ========================================= */}
      <section className="py-5" style={{ backgroundColor: '#eef2f5' }}>
        <div className="container py-4">
          <div className="row g-5">
            
            {/* Target Audience */}
            <div className="col-lg-5 animate-slide-up delay-1">
              <h3 className="fw-bold mb-4 text-dark">👥 Who Reads Our Insights?</h3>
              <p className="text-muted small mb-4">Our publications serve a broad community of financial seekers:</p>
              <div className="d-flex flex-wrap gap-2">
                {[
                  "High Net Worth Individuals (HNIs)", "Entrepreneurs & Business Owners",
                  "Salaried Professionals", "Tax & Legal Practitioners",
                  "FIRE Movement Enthusiasts", "NRIs & Global Investors",
                  "Aspiring Wealth Builders", "Lifelong Learners"
                ].map((item, idx) => (
                  <span key={idx} className="badge bg-white text-dark border p-2 shadow-sm fs-6">
                    {item}
                  </span>
                ))}
              </div>
            </div>

            {/* Why Choose Lotoswealth */}
            <div className="col-lg-7 animate-slide-up delay-2">
              <div className="p-4 bg-white rounded-4 shadow-sm h-100">
                <h3 className="fw-bold mb-3 text-dark">🏆 Why Trust Lotoswealth Publications?</h3>
                <p className="text-muted small mb-4">In a world full of financial noise, quality and accuracy matter. Readers trust our content because we offer:</p>
                <div className="row g-3">
                  {[
                    "Expert Research by Certified Advisors", "Rigorous Fact-Checking & Compliance",
                    "Practical, Actionable Wealth Strategies", "Clear, Jargon-Free Explanations",
                    "Regular Updates on Market Shifts", "Unbiased Financial Perspectives",
                    "Comprehensive Topic Coverage", "Commitment to Financial Literacy"
                  ].map((item, idx) => (
                    <div key={idx} className="col-md-6 d-flex align-items-center">
                      <FaCheckCircle className="text-success me-2 flex-shrink-0" />
                      <span className="small text-muted fw-bold">{item}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* =========================================
          6. FREQUENTLY ASKED QUESTIONS (FAQ)
      ========================================= */}
      <section className="py-5" style={{ backgroundColor: '#f8f9fa' }}>
        <div className="container py-4" style={{ maxWidth: '850px' }}>
          <div className="text-center mb-5 animate-slide-up delay-1">
            <h2 className="fw-bold text-dark">❓ Frequently Asked Questions</h2>
            <p className="text-muted">Common queries regarding our Articles & Knowledge Hub</p>
          </div>

          <div className="d-flex flex-column gap-3 animate-slide-up delay-2">
            {faqs.map((faq, index) => (
              <div 
                key={index} 
                className="bg-white rounded-3 shadow-sm border overflow-hidden"
              >
                <button 
                  className="w-100 text-start p-3 border-0 bg-white d-flex justify-content-between align-items-center fw-bold text-dark"
                  onClick={() => toggleFaq(index)}
                  style={{ cursor: 'pointer' }}
                >
                  <span className="pe-3">{faq.q}</span>
                  <FaChevronDown 
                    className={`text-teal transition-transform ${openFaq === index ? 'rotate-180' : ''}`} 
                    style={{ transition: 'transform 0.3s ease', minWidth: '16px' }}
                  />
                </button>
                {openFaq === index && (
                  <div className="p-3 pt-0 text-muted small border-top bg-light lh-lg">
                    {faq.a}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* =========================================
          7. FINAL CTA SECTION (Deep Navy)
      ========================================= */}
      <section className="py-5 text-white text-center" style={{ backgroundColor: '#0f1e2d' }}>
        <div className="container py-4">
          <h2 className="fw-bold mb-3 animate-slide-up delay-1">Have Questions About Your Financial Strategy?</h2>
          <p className="text-light opacity-75 mb-4 animate-slide-up delay-2 mx-auto" style={{ maxWidth: '600px' }}>
            Don't just read about wealth management—apply it to your portfolio. Schedule a consultation with our expert advisors today.
          </p>
          <button className="btn-custom-teal hover-lift px-5 py-3 fs-5 border-0 rounded text-white shadow animate-slide-up delay-3">
            Schedule a Personal Consultation
          </button>
        </div>
      </section>

    </main>
  );
};

export default Articles;